// src/TimeOffIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var TimeOffIcon = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.826 7.71A3.763 3.763 0 0 0 0.058 11.478c0 2.087 1.688 3.768 3.768 3.768a3.77 3.77 0 0 0 3.768 -3.768A3.763 3.763 0 0 0 3.826 7.71M2.289 9.941H3.826a0.513 0.513 0 0 1 0 1.025H2.289a0.513 0.513 0 0 1 0 -1.025m3.075 3.075H2.289a0.513 0.513 0 0 1 -0.513 -0.513c0 -0.278 0.234 -0.512 0.513 -0.512h3.082c0.287 0 0.513 0.234 0.513 0.512a0.519 0.519 0 0 1 -0.52 0.513",
          fill: "#fff"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.116 0.174H4.579c-2.261 0 -3.768 1.13 -3.768 3.768v2.366c0 0.55 0.565 0.897 1.07 0.678a4.904 4.904 0 0 1 2.758 -0.339c1.974 0.324 3.587 1.884 3.986 3.843 0.113 0.573 0.129 1.13 0.054 1.665 -0.061 0.445 0.301 0.836 0.746 0.836h2.691c2.261 0 3.768 -1.13 3.768 -3.768V3.942c0 -2.638 -1.507 -3.768 -3.768 -3.768m0.354 4.213 -2.358 1.884c-0.498 0.399 -1.131 0.595 -1.764 0.595s-1.273 -0.196 -1.763 -0.595l-2.358 -1.884a0.579 0.579 0 0 1 -0.09 -0.799 0.563 0.563 0 0 1 0.791 -0.09l2.358 1.885c0.573 0.459 1.545 0.459 2.118 0l2.358 -1.884a0.557 0.557 0 0 1 0.792 0.09 0.57 0.57 0 0 1 -0.083 0.799",
          fill: "#fff"
        }
      )
    ]
  }
);
var TimeOffIcon_default = TimeOffIcon;

export {
  TimeOffIcon_default
};
